import React, { useContext, useEffect, useState } from "react";
import { TextContent } from "../../../../shared/TextContent/TextContent";
import DynamicTable from "../../../../shared/DynamicTable/DynamicTable";
import GlobalDataContext from "../../../../shared/GlobalContext/GlobalDataContext";
import ApiDataService from "../../../../services/ApiDataService";
import Spinner from "../../../../shared/Spinner/Spinner";
import { supportedResourcesDescription } from "./SupportedResourcesDescription.js";

function SupportedResources() {
  const [loadSpinner, setLoadSpinner] = useState(false);
  const { metaData, setMetaData } = useContext(GlobalDataContext);
  const [resources, setResources] = useState();
  const [tableData, setTableData] = useState([]);
  const [descriptions, setDescriptions] = useState({});
  const supportedResourcesColumns = ["Resource Name", "Description", "Access"];

  const getDescriptionMap = async (resources) => {
  const descriptionMap = {};

  if (!resources.length || Object.keys(descriptions).length) return;
  setLoadSpinner(true);

  const localDescriptions = {};
  supportedResourcesDescription.forEach(item => {
    localDescriptions[item.Type] = item.Description;
  });

  for (const r of resources) {
    if (localDescriptions[r.type]) {
      descriptionMap[r.type] = localDescriptions[r.type];
    } else {
      console.warn(`No description found for ${r.type}`);
    }
  }

  setLoadSpinner(false);
  setDescriptions(descriptionMap);
};

  const extractDataFromJson = (resources) => {
    return resources
      ?.map((resource) => {
        const resourceObj = { name: "", values: [] };
        resourceObj.name = resource.type;
        //create resource, description, and access values
        resourceObj.values.push(
          { type: "external", value: resource.type, 
            href: `https://hl7.org/fhir/${resource.type.charAt(0).toUpperCase()+resource.type.slice(1)}.html`},
          {
            type: "text",
            value: descriptions[resource.type] || "No description available",
          },
          {
            type: "text",
            value: resource.interaction.map((i) => i.code).includes("create")
              ? "Read & Write"
              : "Read Only",
          }
        );
        return resourceObj;
      })
      .sort((a, b) => a.name.localeCompare(b.name));
  };

  useEffect(() => {
    const json = metaData?.get("capabilityStatement");
    const data = json?.rest[0]?.resource;
    setResources(data);
    if (data && !metaData.capabilityDescriptions) {
      getDescriptionMap(data);
    }
  }, [metaData]);

  useEffect(() => {
    if (Object.keys(descriptions).length) {
      setTableData(extractDataFromJson(resources));
    }
  }, [descriptions]);

  return (
    <>
      <section className="subgroup" id="resources-section">
        <TextContent
          header={"Supported Resources"}
          description={
            "The HL7 FHIR documentation supports a variety of resources. Below are the accessible resources that are supported by the Elevance Health FHIR API."
          }
        />
        {resources && (
          <DynamicTable
            title="Supported Resources"
            columns={supportedResourcesColumns}
            data={tableData}
          />
        )}
      </section>
      {/* Loading spinner */}
      {loadSpinner && <Spinner />}
    </>
  );
}

export default SupportedResources;